"use strict";

class ChildNodeImpl {
  remove() {
    if (!this.parentNode) {
      return;
    }

    this.parentNode.removeChild(this);
  }
}

module.exports = {
  implementation: ChildNodeImpl
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/jsdom/lib/jsdom/living/nodes/ChildNode-impl.js
// module id = +s1g
// module chunks = 1